import React, { useState, useEffect } from 'react';
import profileImage1 from '../image/images.jpg';
import profileImage2 from '../image/images (6).jpg'; 
import profileImage3 from '../image/i8.webp'; 

export default function Hero() {
  const [currentImgIndex, setCurrentImgIndex] = useState(0);

  const images = [profileImage1, profileImage2, profileImage3];

  // --- TYPEWRITER EFFECT STATE & LOGIC ---
  const [typedCount, setTypedCount] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const fullLength = 35; // "“ Speed. Strength. Determination. ”"

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImgIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(timer);
  }, [images.length]);

  // Typewriter Loop Logic
  useEffect(() => {
    const typingSpeed = isDeleting ? 40 : 80;

    const timeout = setTimeout(() => {
      if (!isDeleting && typedCount < fullLength) {
        setTypedCount((prev) => prev + 1);
      } else if (!isDeleting && typedCount === fullLength) {
        setTimeout(() => setIsDeleting(true), 2000);
      } else if (isDeleting && typedCount > 0) {
        setTypedCount((prev) => prev - 1);
      } else if (isDeleting && typedCount === 0) {
        setIsDeleting(false);
      }
    }, typingSpeed);

    return () => clearTimeout(timeout);
  }, [typedCount, isDeleting]);

  // Text slicing logic
  const str1 = "“ Speed.";
  const str2 = " Strength.";
  const str3 = " Determination. ”";

  const part1 = str1.slice(0, typedCount);
  const part2 = str2.slice(0, Math.max(0, typedCount - str1.length));
  const part3 = str3.slice(0, Math.max(0, typedCount - (str1.length + str2.length)));

  return (
    <section id="home" style={styles.heroSection} className="pt-0 pb-5 overflow-hidden position-relative w-100">
      <style>{`
        /* Google Fonts Import */
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@800;900&family=Poppins:wght@400;500;600;700;800;900&display=swap');

        /* Zoom In Animation */
        @keyframes heroZoomIn {
          0% {
            opacity: 0;
            transform: scale(0.95);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }

        .hero-zoom-container {
          animation: heroZoomIn 1.2s cubic-bezier(0.25, 1, 0.5, 1) forwards;
          transform-origin: center center;
          width: 100%;
          max-width: 100%;
          overflow-x: hidden;
        }

        @keyframes floatAthlete {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
          100% { transform: translateY(0px); }
        }

        @keyframes pulseGlow {
          0% { box-shadow: 0 0 0 0 rgba(255, 153, 51, 0.4); }
          70% { box-shadow: 0 0 0 15px rgba(255, 153, 51, 0); }
          100% { box-shadow: 0 0 0 0 rgba(255, 153, 51, 0); }
        }

        @keyframes blinkCursor {
          0%, 100% { opacity: 1; }
          50% { opacity: 0; }
        }
        
        .typewriter-cursor {
          display: inline-block;
          width: 3px;
          height: 1.1em;
          background-color: #FF9933;
          margin-left: 4px;
          vertical-align: middle;
          animation: blinkCursor 0.7s infinite;
        }

        .hero-bg-img {
          -webkit-mask-image: linear-gradient(to right, transparent 0%, rgba(0,0,0,0.5) 18%, #000 38%);
          mask-image: linear-gradient(to right, transparent 0%, rgba(0,0,0,0.5) 18%, #000 38%);
        }

        .mobile-image-section, .mobile-dots-wrap {
          display: none;
        }
        
        /* Mobile & Tablet Responsive Media Queries */
        @media (max-width: 991.98px) {
          .desktop-only-img, .hero-overlay-bg, .dots-control-container {
            display: none !important;
          }

          .hero-text-container {
            text-align: center !important;
            padding-left: 15px !important;
            padding-right: 15px !important;
          }

          .hero-flex-center {
            justify-content: center !important;
          }

          .hero-quote-box {
            border-left: none !important;
            border-top: 3px solid #FF9933 !important;
            border-bottom: 3px solid #FF9933 !important;
            padding-left: 0 !important;
            padding-right: 0 !important;
            padding-top: 12px !important;
            padding-bottom: 12px !important;
          }

          .mobile-image-section {
            display: block;
            width: 100%;
            margin-top: 25px;
            position: relative;
            text-align: center;
          }

          .mobile-dots-wrap {
            display: flex !important;
            justify-content: center;
            align-items: center;
            gap: 10px;
            margin-bottom: 15px;
          }

          .mobile-slider-img {
            width: 100%;
            max-height: 350px;
            object-fit: cover;
            object-position: top center;
            border-radius: 12px;
            box-shadow: 0 8px 20px rgba(0,0,0,0.15);
            transition: opacity 0.5s ease-in-out;
          }
        }

        @media (max-width: 575.98px) {
          .hero-action-btns {
            flex-direction: column;
            width: 100%;
          }
          .hero-action-btns a {
            width: 100%;
            text-align: center;
            box-sizing: border-box;
          }
          .mobile-slider-img {
            max-height: 280px;
          }
          .flag-badge-text {
            font-size: 11px !important;
            letter-spacing: 0.8px !important;
          }
        }

        .slider-dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          cursor: pointer;
          transition: all 0.3s ease;
          border: 2px solid #ffffff;
        }
        .slider-dot:hover {
          transform: scale(1.3);
        }
      `}</style>

      {/* Hero Zoom Container */}
      <div className="hero-zoom-container position-relative">

        {/* DESKTOP Background Image & Overlay */}
        <img 
          key={`desktop-${currentImgIndex}`}
          src={images[currentImgIndex]} 
          alt="Parag Patil" 
          className="hero-bg-img desktop-only-img" 
          style={styles.heroImg} 
        />
        <div className="hero-overlay-bg" style={styles.heroOverlay} />

        {/* DESKTOP Dots Control */}
        <div className="dots-control-container" style={styles.dotsControlWrap}>
          <div className="dots-badge-wrap" style={styles.dotsBadge}>
            {images.map((_, index) => (
              <span
                key={index}
                className="slider-dot"
                onClick={() => setCurrentImgIndex(index)}
                style={{
                  backgroundColor: currentImgIndex === index ? '#FF9933' : 'rgba(0, 0, 128, 0.4)',
                  boxShadow: currentImgIndex === index ? '0 0 8px #FF9933' : 'none',
                }}
              />
            ))}
          </div>

          <div className="faint-scroll-text" style={styles.faintScroll}>
            <span>SCROLL DOWN</span>
            <div style={{ fontSize: '12px', marginTop: '-2px' }}>↓</div>
          </div>
        </div>

        <div className="container py-lg-3 position-relative" style={{ zIndex: 2 }}>
          <div className="row align-items-center min-vh-lg-75 mx-0">
            
            {/* TEXT CONTENT */}
            <div className="col-lg-7 col-xl-6 my-3 hero-text-container px-2 px-sm-3">
              
              {/* Flag Badge */}
              <div style={styles.flagBadge}>
                <span className="flag-badge-text" style={styles.flagBadgeText}>
                  PROUDLY REPRESENTING <span style={{ color: '#FF9933' }}>INDIA 🇮🇳</span>
                </span>
              </div>

              {/* Title */}
              <h1 style={styles.heroTitle}>
                PAARAG <br />
                <span style={styles.saffronText}>PATIL</span>
              </h1>

              {/* Subtitle */}
              <div style={styles.heroSubtitle}>PROFESSIONAL ATHLETE</div>

              {/* Sports Badges */}
              <div className="d-flex flex-wrap gap-2 my-3 hero-flex-center">
                <span style={styles.sportBadge}>🏃 100M RUN</span>
                <span style={styles.sportBadge}>🏃 LONG JUMP</span>
                <span style={styles.sportBadge}>🏃 TRIPLE JUMP</span>
              </div>

              {/* TYPEWRITER QUOTE BOX */}
              <div 
                className="my-4 py-2 hero-quote-box" 
                style={styles.quoteBox}
              >
                <p 
                  className="mb-1 fw-extrabold text-uppercase" 
                  style={styles.typewriterText}
                >
                  <span style={{ color: '#FF9933' }}>{part1}</span>
                  <span style={{ color: '#000080' }}>{part2}</span>
                  <span style={{ color: '#138808' }}>{part3}</span>
                  <span className="typewriter-cursor"></span>
                </p>

                <div className="d-flex align-items-center gap-2 mt-2 hero-flex-center">
                  <div style={{ height: '3px', width: '30px', backgroundColor: '#FF9933', flexShrink: 0 }}></div>
                  <p 
                    className="mb-0 fw-black text-uppercase" 
                    style={styles.subQuoteText}
                  >
                    Representing India with Pride 🇮🇳
                  </p>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="d-flex flex-wrap gap-3 mt-4 hero-action-btns hero-flex-center">
                <a href="#journey" style={{ ...styles.primaryBtn, animation: 'pulseGlow 2s infinite' }}>EXPLORE MY JOURNEY →</a>
                <a href="#achievements" style={styles.secondaryBtn}>VIEW ACHIEVEMENTS →</a>
              </div>
            </div>

            {/* MOBILE/TABLET SLIDER IMAGE */}
            <div className="col-12 mobile-image-section px-0">
              <div className="mobile-dots-wrap">
                {images.map((_, index) => (
                  <span
                    key={index}
                    className="slider-dot"
                    onClick={() => setCurrentImgIndex(index)}
                    style={{
                      backgroundColor: currentImgIndex === index ? '#FF9933' : '#000080',
                      boxShadow: currentImgIndex === index ? '0 0 8px #FF9933' : 'none',
                      transform: currentImgIndex === index ? 'scale(1.2)' : 'scale(1)',
                    }}
                  />
                ))}
              </div>

              <img 
                key={`mobile-${currentImgIndex}`}
                src={images[currentImgIndex]} 
                alt="Parag Patil Athlete" 
                className="mobile-slider-img"
              />
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

const styles = {
  heroSection: {
    background: 'linear-gradient(135deg, #FFF5EC 0%, #FFFFFF 50%, #F0FFF0 100%)',
    minHeight: '85vh',
    display: 'flex',
    alignItems: 'center',
    marginTop: 0,
    paddingTop: 0,
    overflowX: 'hidden',
  },
  heroImg: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: '100%',
    width: '55%',
    objectFit: 'cover',
    objectPosition: 'top center',
    zIndex: 1,
    animation: 'floatAthlete 5s ease-in-out infinite',
    transition: 'all 0.8s ease-in-out',
  },
  heroOverlay: {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(90deg, #FFFFFF 0%, rgba(255,255,255,0.85) 35%, rgba(255,255,255,0) 65%)',
    zIndex: 1,
    pointerEvents: 'none',
  },
  dotsControlWrap: {
    position: 'absolute',
    right: '25px',
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
    zIndex: 10,
  },
  dotsBadge: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    alignItems: 'center',
  },
  faintScroll: {
    color: 'rgba(0, 0, 128, 0.75)',
    fontSize: '9px',
    fontWeight: '800',
    letterSpacing: '1px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    userSelect: 'none',
    fontFamily: "'Poppins', sans-serif",
  },
  flagBadge: {
    display: 'inline-block',
    padding: '6px 14px',
    borderRadius: '20px',
    backgroundColor: '#ffffff',
    border: '2px solid #FF9933',
    marginBottom: '12px',
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
  flagBadgeText: {
    fontSize: '12px',
    letterSpacing: '1px',
    fontWeight: '800',
    color: '#000080',
    fontFamily: "'Poppins', sans-serif",
    display: 'inline-block',
    maxWidth: '100%',
    overflowWrap: 'break-word',
  },
  heroTitle: {
    fontSize: 'clamp(2.2rem, 5vw, 4.8rem)',
    fontWeight: '600',
    color: '#000080',
    lineHeight: '1.05',
    fontFamily: "'Montserrat', sans-serif",
    overflowWrap: 'break-word',
  },
  saffronText: {
    color: '#FF9933',
  },
  heroSubtitle: {
    fontSize: 'clamp(14px, 2.5vw, 18px)',
    fontWeight: '800',
    color: '#138808',
    letterSpacing: '2px',
    marginTop: '6px',
    fontFamily: "'Poppins', sans-serif",
  },
  sportBadge: {
    backgroundColor: '#ffffff',
    border: '1.5px solid #FF9933',
    borderRadius: '20px',
    padding: '6px 14px',
    fontSize: '13px',
    fontWeight: '700',
    color: '#000080',
    fontFamily: "'Poppins', sans-serif",
    whiteSpace: 'nowrap',
  },
  quoteBox: {
    borderLeft: '5px solid #FF9933',
    paddingLeft: '16px',
    minHeight: '70px',
    maxWidth: '100%',
    overflowWrap: 'break-word',
  },
  typewriterText: {
    fontSize: 'clamp(1.1rem, 2.8vw, 1.65rem)',
    letterSpacing: '0.5px',
    lineHeight: '1.4',
    fontFamily: "'Poppins', sans-serif",
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
  },
  subQuoteText: {
    color: '#000080',
    fontSize: 'clamp(0.85rem, 2vw, 1.05rem)',
    letterSpacing: '1px',
    fontFamily: "'Poppins', sans-serif",
  },
  primaryBtn: {
    backgroundColor: '#FF9933',
    color: '#ffffff',
    fontWeight: '800',
    fontSize: '14px',
    padding: '12px 24px',
    borderRadius: '6px',
    textDecoration: 'none',
    display: 'inline-block',
    fontFamily: "'Poppins', sans-serif",
    maxWidth: '100%',
  },
  secondaryBtn: {
    backgroundColor: '#000080',
    color: '#ffffff',
    fontWeight: '800',
    fontSize: '14px',
    padding: '12px 24px',
    borderRadius: '6px',
    textDecoration: 'none',
    display: 'inline-block',
    fontFamily: "'Poppins', sans-serif",
    maxWidth: '100%',
  },
};
